import defaultDataProvider from "./DefaultDataStore";

const customProviders = {};
const registerProvider = (resource, provider) => {
    console.log('Registering custom data provider for resource: ' + resource);
    customProviders[resource] = provider;
}

const DataProviderFactory = (type, resource, params) => {

    console.log('Data Provider Factory Request: ' + type + ' ' + resource + ' ' + params)
    if (customProviders[resource]) {
        console.log('Using custom provider');
        return customProviders[resource](type, resource, params);
    }
    else {
        console.log('Using default provider');
        return defaultDataProvider(type, resource, params);
    }
};

export {DataProviderFactory, registerProvider};


